import classNames from 'classnames'
import { ArtworkDetailsSkeleton } from 'components/artwork/ArtworkDetailsSkeleton'
import { ArtworkTags } from 'components/artwork/ArtworkTags'
import { Badge } from 'components/common/Badge'
import { Button } from 'components/common/Button'
import { Info } from 'components/common/Info'
import { SaveButton } from 'components/common/SaveButton'
import { SlideShow } from 'components/common/SlideShow'
import { BaseLayout } from 'layouts/BaseLayout'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { PropsWithClassName } from 'types'

export const ArtworkPageSkeleton = () => {
  const { t } = useTranslation()

  return (
    <BaseLayout style='off-white-bg'>
      <div className='mt-4 sm:mt-6'>
        <div className='container pb-20'>
          <div className='max-w-[550px] lg:mb-6'>
            <Skeleton width='100%' height={22} borderRadius={8} />
          </div>

          <div className='block grid-cols-6 grid-areas-artwork sm:px-6 md:grid-cols-12 md:px-0 md:grid-areas-artworkMd lg:grid lg:space-x-4 lg:space-y-0 lg:grid-areas-artworkLg'>
            <div className='relative mb-5 h-[260px] w-full grid-in-artwork-gallery sm:h-[300px] lg:row-span-3 lg:mb-0 lg:h-full lg:pr-12'>
              <SlideShow className='lg:pt-0' />

              <div className='hidden lg:block'>
                <SaveButton />
              </div>
            </div>

            <div className='grid-in-artwork-header'>
              <header className='mb-[10px] flex items-start justify-between'>
                <div className='flex flex-col space-y-3'>
                  <Skeleton width={157} height={32} borderRadius={8} />
                  <h5 className='font-medium md:hidden'>
                    <Skeleton height={36} borderRadius={8} />
                  </h5>
                  <h4 className='hidden font-medium md:block'>
                    <Skeleton height={44} width={233} borderRadius={8} />
                  </h4>
                </div>
                <Badge
                  type='Artist'
                  className='h-12 w-12 sm:h-16 sm:w-16 xl:h-20 xl:w-20'
                />
              </header>

              <Skeleton width={207} height={32} className='mb-8' />

              <ArtworkTradeSkeleton />

              <div className='mt-6 grid grid-cols-3 space-x-4'>
                <Button style='outline' className='whitespace-nowrap'>
                  {t('common:view_listings')}
                </Button>
                <Button style='outline' className='whitespace-nowrap'>
                  {t('common:view_bids')}
                </Button>
                <Button style='outline' className='whitespace-nowrap'>
                  {t('common:view_sales')}
                </Button>
              </div>
            </div>

            <div className='mt-8 grid-in-artwork-body lg:mt-4 lg:min-h-[510px] lg:pt-8'>
              <ArtworkTags isVerified isNewCondition />

              <ArtworkDetailsSkeleton />
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  )
}

export function ArtworkTradeSkeleton({ className }: PropsWithClassName) {
  return (
    <div
      className={classNames(
        'rounded border-cool-300 lg:border lg:bg-cool-50 lg:px-4 lg:py-5',
        className
      )}
    >
      <Skeleton width='100%' height={48} borderRadius={8} />

      <Info className='mt-5'>
        <Trans
          i18nKey='common:learn_how_buying_or_selling_works'
          components={{
            comp1: <button className='text-secondary-default underline' />,
            comp2: <button className='text-secondary-default underline' />,
          }}
        />
      </Info>
    </div>
  )
}
